import styled from 'styled-components';

export const DropzoneBox = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 24px 16px;
    border: 1px dashed ${(props) => props.theme.palette.primaryA1};
    border-radius: 8px;
    cursor: pointer;
    text-align: center;

    &.is-drag-active {
        border-style: solid;
        background-color: ${(props) => props.theme.palette.primaryA5};
    }

    &.has-error {
        border-color: ${(props) => props.theme.palette.secondaryA4};
    }

    .upload-icon {
        color: ${(props) => props.theme.palette.primaryA1};
    }

    .file-row {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .delete-icon {
        width: 20px;
        flex-shrink: 0;
    }

    .hint {
        margin: 0;
    }
`;
